module.exports = __webpack_public_path__ + "img/bm-google.c09947d6.png";